module.exports = __webpack_public_path__ + "img/img_Colleges2.1f357597.png";